export interface ProviderViewModel {
  readonly id: string;
  readonly name: string;
  readonly email: string;
  readonly phoneNumber: string;
}

// calchez-protos と wabunka-protos の Provider 両方を受け入れるための最小限の構造
interface ProviderLike {
  id: string;
  name: string;
  email: string;
  privateInfo?: { phoneNumber: string } | undefined;
}

/**
 * プロバイダーのデフォルト値を返却する
 * @returns プロバイダー
 */
export const createDefaultProviderViewModel = (): ProviderViewModel => ({
  id: '',
  name: '',
  email: '',
  phoneNumber: '',
});

/**
 * 事業者のビューモデルを組み立てて返却する
 */
export const buildProviderViewModel = (provider: ProviderLike | undefined): ProviderViewModel => {
  if (!provider) return createDefaultProviderViewModel();

  return {
    id: provider.id,
    name: provider.name,
    email: provider.email,
    phoneNumber: provider.privateInfo?.phoneNumber ?? '',
  };
};
